<template lang="jade">
  div
    JourneyPicker(:journeys="journeys", :loadCallback="null")

    table
      thead
        tr
          th
            button.btn.btn3d.btn-info.btn-sm(style="width: 100px;", @click="setAutoCompleting") Autocompletar
          th 1ª Entrada
          th 1ª Saída
          th 2ª Entrada
          th 2ª Saída
          th(width="12%") Jornada
        tr(v-if="autoCompleting")
          th(colspan="6")
            AutoComplete
      tbody(v-for="(row, rindex) in rows", :class="{'line-selected': selectedLines.includes(rindex)}")
        image-sheet(:row="row", :rindex="rindex")
        input-sheet(:ref="rindex.toString()", :row="row", :rindex="rindex", :onChangeFocus="changeFocus",
          @focusAutoComplete="setAutoCompleting")

</template>

<script>
import ImageSheet from './ImageSheet.vue'
import InputSheet from './InputSheet.vue'
import AutoComplete from './AutoComplete/AutoComplete.vue'
import JourneyPicker from '../common/JourneyPicker'

export default {
  computed: {
    selectedLines () {
      return this.$store.state.Sheet.selectedLines
    },
    journeys () {
      return this.$store.state.Sheet.journeys
    },
    rows () {
      return this.$store.getters.currentSheetRows
    },
    autoCompleting () { return this.$store.getters.autoCompleting }
  },
  components: {
    ImageSheet,
    InputSheet,
    JourneyPicker,
    AutoComplete
  },
  methods: {
    changeFocus (id, pos) {
      this.$refs[pos[0].toString()][0].$refs[id][0].$el.firstChild.focus()
      this.$refs[pos[0].toString()][0].$refs[id][0].$el.firstChild.select()
    },
    setAutoCompleting () {
      this.$store.dispatch('autoCompleting', !this.autoCompleting)
    }
  },
  async created () {
    setTimeout(() => {
      this.changeFocus(this.$store.getters.currentDigit.id, this.$store.getters.currentDigit.position)
    }, 100)
  },
  provide: {
    openDayJourney (rowInfo, type = 'modal', action = null) {
      console.log('fsafdsa', rowInfo, type)

      let elList = document.querySelectorAll(`.DayJourney-${rowInfo}`)
      const DjComponent = elList[elList.length - 1]

      if (!DjComponent.__vue__) {
        action = action !== 'next' ? -1 : +1
        this.openDayJourney(rowInfo + action, type, action)
      }

      if (type === 'modal') {
        DjComponent.__vue__.activeModal()
      } else if (type === 'search') {
        DjComponent.__vue__.editDj()
      }
    }
  }
}
</script>

<style scoped>
  th {
    text-align: center;
  }
  table {
    border-collapse: collapse;
  }

  table tbody {
    border-top: 15px solid white;
  }
  .line-selected {
    background-color: gainsboro;
  }
</style>



// WEBPACK FOOTER //
// Sheet.vue?43b88704